import { motion, useSpring } from "framer-motion";
import { useEffect } from "react";

const orbSize = 80;

const TutorialInfinityOrb = () => {
  const ySpring = useSpring(0, {
    stiffness: 60,
    damping: 15,
  });

  useEffect(() => {
    const loop = () => {
      ySpring.set(-5);
      setTimeout(() => ySpring.set(5), 500);
    };

    loop();
    const interval = setInterval(loop, 1000);
    return () => clearInterval(interval);
  }, [ySpring]);

  return (
    <motion.div
      style={{
        position: "absolute",
        left: "50%",
        top: "50%",
        x: "-50%",
        y: ySpring,
        width: orbSize,
        height: orbSize,
        zIndex: 9999,
      }}
    >
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundImage: `url(${require("../@shared/assets/sprites/infinityOrb-ns-sprite.png")})`,
            backgroundPosition: "0px 0px",
            backgroundRepeat: "no-repeat",
            backgroundSize: `${orbSize * 4}px ${orbSize}px`,
            zIndex: 2,
          }}
        />

        <div
          style={{
            width: "50%",
            height: "58%",
            position: "absolute",
            top: "50%",
            left: "54%",
            transform: "translate(-50%, -50%)",
            background:
              "radial-gradient(rgb(116, 249, 116), rgba(0, 41, 0, 0.8))",
            borderRadius: "50%",
            zIndex: 1,
          }}
        />
      </div>
    </motion.div>
  );
};

export default TutorialInfinityOrb;
